<div class="loader">{{data}}...</div>
